import DriveHeader from '@/components/DriveHeader.tsx'
import { Loading } from 'react-daisyui'
import { IconCircleCheck } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { useDrives } from '@/stores/useDrives.ts'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useClient } from '@/stores/useClient.ts'
import { useTranslation } from 'react-i18next'

export default function StripePaymentSuccessPage() {
  // const { session_id } = useParams<{session_id: string}>()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const session_id = searchParams.get('session_id')
  const { currentDrive } = useDrives()
  const navigate = useNavigate()
  const { getPaymentStatus } = useClient()
  const [redirectUri, setRedirectUri] = useState<null | string>(null)

  useEffect(() => {
    const id = setInterval(async () => {
      const res = await getPaymentStatus(currentDrive!.id, session_id!)
      const data = res.data as {
        session_id: string
        payment_status: string
        session_status: string
        redirect_action: 'storage_increase_complete' | 'payment_pending' | 'order_complete'
        metadata: any
        order_id?: string
        basket_id?: string
      }

      if (data.redirect_action === 'storage_increase_complete') {
        setRedirectUri(`/d/${currentDrive!.id}/storage`)
      } else if (data.redirect_action === 'order_complete' && data.order_id) {
        setRedirectUri(`/d/${currentDrive!.id}/shop/orders/${data.order_id}`)
      }
    }, 1000)

    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    if (redirectUri) {
      navigate(redirectUri)
    }
  }, [redirectUri]);

  return <div>
    <DriveHeader />
    <div className="container mx-auto flex flex-col gap-3 justify-center items-center py-5">
      <div className='flex flex-row gap-3 items-center font-bold'>
        <IconCircleCheck className='text-primary' size={48} />
        <span className='text-xl'>{t('payment.paymentSuccessful')}</span>
      </div>
      <div className='flex flex-row gap-3 items-center mt-5'>
        <Loading color='primary' /> {t('payment.paymentBeingProcessed')}
      </div>
    </div>
  </div>
}
